import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { apiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Register = () => {
  const { register } = useAuth();
  const { t } = useI18n();
  // L'email arriva dal popup della Memoria Operativa: non la facciamo riscrivere.
  const [form, setForm] = useState({
    name: "", company: "", password: "",
    email: localStorage.getItem("op_email") || "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const field = (id, label, type = "text", required = true) => (
    <div>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        data-testid={`register-${id}`}
        type={type}
        required={required}
        value={form[id]}
        onChange={(e) => setForm({ ...form, [id]: e.target.value })}
        className="mt-1.5 focus:ring-2 focus:ring-blue-600"
      />
    </div>
  );

  return (
    <AuthShell
      title={t("register.title")}
      subtitle={t("register.subtitle")}
      footer={
        <>
          {t("register.hasAccount")}{" "}
          <Link to="/login" data-testid="go-login" className="font-semibold text-blue-600 hover:underline">
            {t("register.login")}
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        {field("name", t("register.name"))}
        {field("company", t("register.company"), "text", false)}
        {field("email", t("common.email"), "email")}
        {field("password", t("register.password"), "password")}
        {error && (
          <p data-testid="register-error" className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">
            {error}
          </p>
        )}
        <Button
          data-testid="register-submit"
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white hover:bg-blue-700"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : t("register.submit")}
        </Button>
      </form>
    </AuthShell>
  );
};

export default Register;
